import { __assign } from "tslib";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import Background from '../../../../Background';
import { DEFAULT_STATUS_PATTERNS } from '../../../../Background/constants';
import TextRenderer from '../../../../TextRenderer';
import { ShortStatusViewer } from '../../../../DaEditorWrapper/Viewer/Status';
import { getStatusBackgroundProps } from '../../../_helpers';
import draftTheme from '../../../../DaEditorWrapper/Themes/Viewer/feedcard.scss';
import legacyTheme from '../../feedcard.legacy.theme.scss';
import s from './ShortStatus.scss';
// note: only short statuses have backgrounds
// TODO: these are custom versions of the backgrounds in Background/constants.ts
// used in the postfeed (w/ a variant for mobile) - look into simplifying.
// Until then and for delete-ability, these are here instead of there.
var POSTFEED_STATUS_PATTERNS = ['meteors', 'hearts', 'stars', 'planets'];
var PATTERN_CDN_PATH = '/eclipse/global/svg/status-backgrounds';
/** Replaces one of the standard Background status patterns with a custom one for the postfeed */
function buildPatternUrl(pattern, isMobile) {
    var index = DEFAULT_STATUS_PATTERNS.indexOf(pattern);
    // e.g. desktop: 'https://st.deviantart.net/eclipse/global/svg/status-backgrounds/meteors.svg',
    // mobile: 'https://st.deviantart.net/eclipse/global/svg/status-backgrounds/meteors-mobile.svg',
    var newPattern = POSTFEED_STATUS_PATTERNS[index];
    var mobileSuffix = isMobile ? '-mobile' : '';
    return newPattern
        ? Url.staticCDNLink("".concat(PATTERN_CDN_PATH, "/").concat(newPattern).concat(mobileSuffix, ".svg"))
        : undefined;
}
var ShortStatusFeedCardContents = function (_a) {
    var deviation = _a.deviation, width = _a.width;
    var isMobile = useContext(MobileContext);
    var tier = useSubscriptionTier(deviation).tier;
    var backgroundProps = getStatusBackgroundProps(deviation);
    var customPattern = buildPatternUrl(backgroundProps === null || backgroundProps === void 0 ? void 0 : backgroundProps.pattern, isMobile);
    if (customPattern) {
        backgroundProps = __assign(__assign({}, backgroundProps), { pattern: customPattern });
    }
    return (React.createElement(Background, __assign({ className: classnames(s['background'], !!tier && s['in-tier']), contentClassName: s['background-content'], width: width, variant: "status" }, backgroundProps),
        !!tier && React.createElement(TierBadge, { size: 40 }),
        React.createElement(TextRenderer, { textContent: deviation.textContent, reactViewer: ShortStatusViewer, viewerKey: deviation.deviationId, legacyTheme: "short-status", fixedParagraph: false, disableLazyLoading: true, draftjsThemeOverride: draftTheme, className: classnames(legacyTheme['legacy'], legacyTheme['override'], draftTheme['override'], legacyTheme['short-status']) })));
};
ShortStatusFeedCardContents.displayName = 'ShortStatusFeedCardContents';
export default ShortStatusFeedCardContents;
//# sourceMappingURL=ShortStatus.js.map